export default "__VITE_ASSET__de9d7780__"